module.exports = __webpack_public_path__ + "img/ticket5.ce2c4cc8.png";